import { render, staticRenderFns } from "./creatExpress.vue?vue&type=template&id=3455e228&scoped=true"
import script from "./creatExpress.vue?vue&type=script&lang=js"
export * from "./creatExpress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3455e228",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/yunxiao/be-3sdnltdmmjqei95chipgpfz5/runner/__flow_work/__flow_builds/182a3969-2a32-4dff-94d8-cf1bbedf203a/workspace/crmeb-mer-admin_BNnv/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3455e228')) {
      api.createRecord('3455e228', component.options)
    } else {
      api.reload('3455e228', component.options)
    }
    module.hot.accept("./creatExpress.vue?vue&type=template&id=3455e228&scoped=true", function () {
      api.rerender('3455e228', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/systemSetting/logisticsManagement/creatExpress.vue"
export default component.exports